const demoEvents = [
    {
        id: 1,
        date: new Date(2023, 10, 5, 18, 30),
        title: 'Youth Board Game Night',
        description: 'Bring a snack and your favorite game. This event is hosted by the youth group, but everyone is invited. Whether your game is checkers, Catan, or Axis & Allies, there\'s something for you'
    },
    {
        id: 2,
        date: new Date(2023, 10, 13, 13),
        title: 'Lunch Potluck',
        description: 'Bring a main dish and a dessert. Crock pots can be left in the learning center. Drinks will be provided. Any help setting up chairs at 12:30 would be much appreciated!'
    },
    {
        id: 3,
        date: new Date(2023, 10, 30, 19),
        title: 'NO WEDNESDAY NIGHT CHURCH',
        description: 'Pastor Frank will be out of town, and there will also be no child care. If you are interested in filling in, please reach out to the main church number. If we are able to find child-care, we will remove this event from the calendar.'
    }
];

export default demoEvents;
